import Icon from 'components/Icon';
import IconButton from 'components/IconButton';
import useIsMobile from 'hooks/useIsMobile';
import * as React from 'react';
import {
  Button, Menu, MenuItem, Typography,
} from '@mui/material';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext, OverlayContext } from 'constants/contexts';
import { triggerAnalyticEvent } from 'utils/analytics';

function ProfileButton() {
  const isMobile = useIsMobile();
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const history = useHistory();

  const {
    logout, isLoggedIn, redirectAfterLoggedIn, user, profileIsComplete,
  } = useContext(AuthContext);

  const [openOverlay, closeOverlay] = useContext(OverlayContext);
  const links = [
    {
      title: 'Profile',
      icon: 'user-outlined',
      to: '/profile/account',
      component: Link,
    },
    {
      title: 'Support',
      icon: 'support-outlined',
      to: '/profile/Support',
      component: Link,
    },
    {
      title: 'Orders',
      icon: 'order-outlined',
      to: '/profile/orders',
      component: Link,
    },
    {
      title: 'Sign out',
      icon: 'logout-outlined',
      color: 'error.main',
      onClick: handleLogout,
    },
  ];
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  function handleClick(event) {
    if (!isLoggedIn) {
      redirectAfterLoggedIn();
      return;
    }
    setAnchorElUser(event.currentTarget);
  }

  function handleLogout() {
    openOverlay({
      title: 'Sign out',
      body: 'Are you sure you want to sign out?',
      onClose: closeOverlay,
      actions: (
        <>
          <Button onClick={closeOverlay}>
            cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              logout();
              localStorage.removeItem('persist:root');
              triggerAnalyticEvent('logout');
              closeOverlay();
            }}
          >
            Sign out
          </Button>
        </>
      ),
    });
  }

  function handleCompleteProfile() {
    history.push('/signup');
  }

  if (!isLoggedIn) {
    return isMobile ? (
      <IconButton name="login-outlined" variant="primary" onClick={handleClick} />
    ) : (
      <Button variant="contained" size="medium" sx={{ gap: 1 }} onClick={handleClick}>
        <Icon name="login-outlined" size={{ xs: 24, lg: 20 }} />
        <Typography variant="label-md">Login</Typography>
      </Button>
    );
  }

  if (isLoggedIn && !profileIsComplete) {
    return isMobile ? (
      <IconButton variant="muted" name="completeprofile-outlined" onClick={handleCompleteProfile} />
    ) : (
      <Button
        variant="muted"
        size="medium"
        onClick={handleCompleteProfile}
        sx={{ gap: 1 }}
      >
        <Icon name="completeprofile-outlined" size={{ xs: 24, lg: 20 }} />
        <Typography variant="label-md" data-testid="user-name">Complete profile</Typography>
      </Button>
    );
  }

  return (
    <>
      {isMobile ? (
        <IconButton name="user-outlined" onClick={handleClick} />
      ) : (
        <Button
          variant="contained"
          size="medium"
          onClick={handleClick}
          sx={{ gap: 1, backgroundColor: 'background.elevation1', color: 'text.primary' }}
        >
          <Icon name="user-outlined" size={{ xs: 24, lg: 20 }} />
          <Typography variant="label-md" data-testid="user-name">{user?.name}</Typography>
        </Button>
      )}

      <Menu
        sx={{ mt: '48px' }}
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {links.map(({
          title, icon, color, ...props
        }) => (
          <MenuItem key={title} onClick={handleCloseUserMenu} sx={{ gap: 1, width: '160px', color }} {...props}>
            <Icon name={icon} size={20} />
            <Typography variant="body-md" color={color || 'text.primary'}>
              {title}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ProfileButton;
